function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEyeOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.828,
    height: 22.828,
    viewBox: "0 0 22.828 22.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-eye-off"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 314",
    d: "M16.9 18.673a9.155 9.155 0 0 1-5.4 1.873c-6.364 0-10-7.273-10-7.273a16.773 16.773 0 0 1 4.6-5.4m3.491-1.655A8.291 8.291 0 0 1 11.5 6c6.364 0 10 7.273 10 7.273a16.818 16.818 0 0 1-1.964 2.9m-6.109-.973a2.727 2.727 0 1 1-3.855-3.855",
    transform: "translate(-.086 -1.859)",
    style: {
      fill: "none",
      stroke: "#101728",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 315",
    d: "m1.5 1.5 20 20",
    style: {
      fill: "none",
      stroke: "#101728",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(-.086 -.086)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeOff);
export default __webpack_public_path__ + "static/media/ic-eye-off.189721289159ec0680a04f24d4cb07cf.svg";
export { ForwardRef as ReactComponent };